import type { IntlShape } from 'react-intl';
import { resolveCompanyLogoAltDisplayName } from './resolve-company-logo-alt-display-name';

const LOGO_ALT_NAMED = {
  id: 'company.logoAlt',
  defaultMessage: '{company} logo',
  description: 'Accessibility text for company logo image, where {company} is the company name',
} as const;

const LOGO_ALT_GENERIC = {
  id: 'company.logoAltGeneric',
  defaultMessage: 'Employer logo',
  description: 'Accessibility text when the employer name is unknown',
} as const;

/**
 * Localized logo alt for React components (current page locale via react-intl).
 * Non-empty explicit `alt` wins (call-site override).
 */
export function formatCompanyLogoAltLabelFromProps(
  intl: IntlShape,
  props: {
    alt?: string;
    initialsSourceName?: string | null;
    companyName?: string | null;
    companyId?: string | null;
  }
): string {
  const { alt, initialsSourceName, companyName, companyId } = props;
  if (alt !== undefined && alt !== '') {
    return alt;
  }
  const displayName = resolveCompanyLogoAltDisplayName(initialsSourceName, companyName, companyId);
  if (displayName) {
    return intl.formatMessage(LOGO_ALT_NAMED, { company: displayName });
  }
  return intl.formatMessage(LOGO_ALT_GENERIC);
}
